import { render, staticRenderFns } from "./WelcomeV2.vue?vue&type=template&id=62b2df34&"
import script from "./WelcomeV2.vue?vue&type=script&lang=js&"
export * from "./WelcomeV2.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeV2.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
